<template>
    <div v-observe-visibility="visibilityChanged">

        <!--Confirming Position - Loading-->
        <v-dialog class="loading-dialog"
                  v-model="confirmPositionLoading"
                  persistent
                  overlay
                  max-width="450px">
            <v-card>
                <v-layout row pt-4 pb-4 pr-4 pl-4>
                    <v-flex grow>
                        <v-card-title class="headline">Picking Position...</v-card-title>
                    </v-flex>
                    <v-flex shrink>
                        <v-progress-circular
                                :size="70"
                                :width="7"
                                color="primary"
                                indeterminate
                        ></v-progress-circular>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-dialog>

        <!--DELETE - Dialog-->
        <v-dialog
                persistent
                v-model="deleteDialog" max-width="400px">
            <v-card>
                <v-card-title>
                    <span class="headline">Delete Position</span>
                </v-card-title>

                <v-card-text>
                    <v-form ref="deleteForm" v-model="deleteFormValidation" lazy-validation>
                        <v-checkbox
                                :rules="[v => !!v || 'You have to check this to continue!']"
                                required
                                v-model="deleteChecked" color="primary"
                                label="Do you really want to delete this position?"></v-checkbox>
                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary darken-1" flat @click.native="cancelDeleteDialog()">CANCEL</v-btn>
                    <v-btn color="primary darken-1" flat @click.native="deletePosition()">
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--PICKING - Dialog-->
        <v-dialog
                persistent
                v-model="pickPositionDialogState" max-width="400px">
            <v-card>
                <v-card-title>
                    <span class="headline">Pick Position</span>
                </v-card-title>

                <v-card-text>
                    Do you really want to pick this position?
                    <v-flex sm12 pl-4 pa-2>
                        <v-text-field
                                label="Quantity"
                                v-model="invoicePositionToPick.quantity"
                                type="number"
                                min="1"
                                :max="invoicePositionToPick.quantity"
                        ></v-text-field>
                    </v-flex>

                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary darken-1" flat @click.native="cancelPickPositionDialog()">CANCEL</v-btn>
                    <v-btn color="primary darken-1" flat @click.native="savePickingPosition()">
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-layout id="table-container" row wrap>
            <v-flex xs12 lg6 pr-4 pt-4 pl-4>
                <v-card>
                    <v-card-title>
                        Unpicked Invoice Positions
                        <v-spacer></v-spacer>
                        <v-text-field
                                v-model="search"
                                append-icon="search"
                                label="Search"
                                single-line
                                hide-details
                                clearable
                        ></v-text-field>
                    </v-card-title>

                    <v-data-table
                            :headers="invoiceHeaders"
                            :items="getItems"
                            :pagination.sync="pagination"
                            :total-items=total
                            class="elevation-0 offer-table"
                            :loading="loadingPositions"
                            :rows-per-page-items="rowsPageItems"
                    >

                        <template slot="headerCell" slot-scope="props">
                            <v-tooltip bottom>
                                        <span slot="activator">
                                          {{ props.header.text }}
                                        </span>
                                <span>
                                          {{ props.header.text }}
                                        </span>
                            </v-tooltip>
                        </template>
                        <template slot="items" slot-scope="props">
                            <tr @dblclick="pickPositionDialog(props.item)">
                                <td>{{ props.item.id }}</td>
                                <td class="text-xs-left">{{
                                    props.item.product.reference }}
                                </td>
                                <td class="text-xs-left">{{
                                    props.item.product.manufacturer.name }}
                                </td>
                                <td class="text-xs-left">{{ positionQuantityLeft(props.item) }}</td>
                                <td class="text-xs-left">{{props.item.unit.code }}</td>
                                <td class="text-xs-right">
                                    <v-icon color="green"
                                            class="ma-1"
                                            @click="pickPositionDialog(props.item)"
                                    >
                                        fal fa-box-check
                                    </v-icon>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>

                </v-card>
            </v-flex>

            <v-flex xs12 lg6 pr-4 pt-4 pl-4>
                <v-card>
                    <v-card-title>
                        Picked Positions
                        <v-spacer></v-spacer>
                        <v-text-field
                                v-model="search"
                                append-icon="search"
                                label="Search"
                                single-line
                                hide-details
                                clearable
                        ></v-text-field>
                    </v-card-title>

                    <v-data-table
                            :headers="pickingHeaders"
                            :items="getPickedItems"
                            :pagination.sync="pagination"
                            :total-items=total
                            class="elevation-0 offer-table"
                            :loading="loadingPositions"
                            :rows-per-page-items="rowsPageItems"
                    >

                        <template slot="headerCell" slot-scope="props">
                            <v-tooltip bottom>
                                        <span slot="activator">
                                          {{ props.header.text }}
                                        </span>
                                <span>
                                          {{ props.header.text }}
                                        </span>
                            </v-tooltip>
                        </template>
                        <template slot="items" slot-scope="props">
                            <tr @dblclick="openSelectedInvoicePosition(props.item.id)">
                                <td>{{ props.item.id }}</td>
                                <td class="text-xs-left">{{
                                    props.item.invoice_position.product.reference }}
                                </td>
                                <td class="text-xs-left">{{
                                    props.item.invoice_position.product.manufacturer.name }}
                                </td>
                                <td class="text-xs-left">{{ props.item.quantity }}</td>
                                <td class="text-xs-left">{{props.item.invoice_position.unit.code }}</td>

                                <td class="text-xs-right">
                                    <v-icon color="red"
                                            class="ma-1"
                                            @click="deletePositionDialog(props.item)"
                                    >
                                        delete
                                    </v-icon>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>

                </v-card>
            </v-flex>
        </v-layout>

    </div>
</template>

<script>
import {
  Settings,
  Invoice,
  InvoicePosition,
  Picking,
  PickingPosition
} from '../../../../store/namespace-helper'
import {numberFormatFilters} from '../../../../mixins/numberFormatFilters'

import _ from 'lodash'

export default {
  mixins: [numberFormatFilters],
  name: 'invoice-positions',
  components: {},
  data () {
    return {
      isVisible: false,
      hide: true,
      activeTab: 0,
      invoiceHeaders: [
        {text: 'Position-ID', value: 'id'},
        {text: 'Reference', value: 'reference'},
        {text: 'Manufacturer', value: 'manufacturers_id'},
        {text: 'Received Quantity Left', value: 'quantity'},
        {text: 'Unit', value: 'unit_id', sortable: false},
        {text: 'Actions', value: 'actions', sortable: false, align: 'right'}
      ],
      pickingHeaders: [
        {text: 'Position-ID', value: 'id'},
        {text: 'Reference', value: 'reference'},
        {text: 'Manufacturer', value: 'manufacturers_id'},
        {text: 'Quantity Picked', value: 'quantity'},
        {text: 'Unit', value: 'unit_id', sortable: false},
        {text: 'Actions', value: 'actions', sortable: false, align: 'right'}
      ],
      pagination: {},
      search: '',
      total: 0,
      rowsPageItems: [{'text': 'All', 'value': -1}],
      creatingInvoice: false,
      positionData: null,
      deleteDialog: false,
      deleteChecked: false,
      deleteFormValidation: false,
      loadingPositions: false,
      addDialog: false,
      pickPositionDialogState: false,
      invoicePositionToPick: {},
      startPickingLoading: false,
      confirmPositionLoading: false
    }
  },
  mounted () {

  },
  methods: {
    visibilityChanged (isVisible, entry) {
      if (this.isVisible !== isVisible) {
        this.isVisible = isVisible
        if (isVisible) {
          console.log('tab order positions visible, load data')
          this.loadItems()
          this.loadPickingItems()
        } else {

        }
      }
    },
    loadItems: function () {
      const {sortBy, descending, page, rowsPerPage} = this.pagination
      const query = {
        id: this.selectedItem.invoices_id,
        sortBy: sortBy || 'id',
        descending: descending ? 'desc' : 'asc',
        page: page || 1,
        limit: rowsPerPage !== -1 ? rowsPerPage : 0,
        search: this.search ? this.search : ''
      }
      if (this.selectedItem.selectedItem !== 0) {
        this.loadingPositions = true
        this.$store.dispatch(InvoicePosition.actions.loadInvoicePositionForInvoice, query).then(response => {
          this.loadingPositions = false
        }).catch(err => {
          console.log(JSON.stringify(err))
          this.loadingPositions = false
        })
      }
    },
    loadPickingItems: function () {
      const {sortBy, descending, page, rowsPerPage} = this.pagination
      const query = {
        id: this.selectedItem.id,
        sortBy: sortBy || 'id',
        descending: descending ? 'desc' : 'asc',
        page: page || 1,
        limit: rowsPerPage !== -1 ? rowsPerPage : 0,
        search: this.search ? this.search : ''
      }
      if (this.selectedItem.id !== 0) {
        this.loadingPositions = true
        this.$store.dispatch(PickingPosition.actions.loadPickingPositionForPicking, query).then(response => {
          this.loadingPositions = false
        }).catch(err => {
          console.log(JSON.stringify(err))
          this.loadingPositions = false
        })
      }
    },
    startPicking () {
      this.startPickingLoading = true
      this.$store.dispatch(Invoice.actions.startPicking, this.selectedItem).then(response => {
        this.startPickingLoading = false
      }).catch(reason => {
        this.startPickingLoading = false
      })
    },
    savePickingPosition () {
      this.confirmPositionLoading = true
      this.pickPositionDialogState = false

      var pickingPosition = {
        id: 0,
        pickings_id: this.selectedItem.id,
        invoices_positions_id: this.invoicePositionToPick.id,
        quantity: this.invoicePositionToPick.quantity
      }

      this.$store.dispatch(PickingPosition.actions.savePickingPosition, pickingPosition).then(response => {
        this.confirmPositionLoading = false
        this.loadItems()
        this.loadPickingItems()
      }).catch(reason => {
        this.confirmPositionLoading = false
      })
    },
    openConfirmDialog (val) {
      var item = this.getItems.find(x => x.id === val)
      if (item !== null && typeof item !== 'undefined') {
        console.log('selectedInvoicePosition: ' + JSON.stringify(item))
        this.$store.dispatch(InvoicePosition.actions.setSelectedInvoicePosition, item)
      }
      this.confirmDialogState = true
    },
    cancelPickPositionDialog () {
      this.invoicePositionToPick = {}
      this.pickPositionDialogState = false
    },
    openSelectedInvoicePosition (val) {
      var item = this.getItems.find(x => x.id === val)
      if (item !== null && typeof item !== 'undefined') {
        console.log('selectedInvoicePosition: ' + JSON.stringify(item))
        this.$store.dispatch(InvoicePosition.actions.setSelectedInvoicePosition, item)
      }
      this.addDialog = true
    },
    throttledLoadItems: _.debounce(function () {
      this.loadItems()
    }, 450),
    throttledTranslate: _.debounce(function (q, target) {
      this.translate(q, target)
    }, 450),
    deletePositionDialog (item) {
      this.positionData = _.cloneDeep(item)
      this.deleteDialog = true
    },
    pickPositionDialog (item) {
      this.invoicePositionToPick = _.cloneDeep(item)
      this.invoicePositionToPick.quantity = this.positionQuantityLeft(item)
      this.pickPositionDialogState = true
    },
    deletePosition () {
      if (!this.$refs.deleteForm.validate()) {
        return
      }
      this.deleteDialog = false
      this.deleteChecked = false
      this.$store.dispatch(PickingPosition.actions.deletePickingPosition, this.positionData).then(response => {
        if (response !== null) {
          this.loadItems()
          this.loadPickingItems()
        }
      })
    },
    cancelDeleteDialog () {
      this.deleteDialog = false
      this.$refs.deleteForm.reset()
    },
    closeAddEditPositionDialog () {
      this.$store.dispatch(InvoicePosition.actions.setSelectedInvoicePosition, null)
      this.addDialog = false
    },
    positionQuantityLeft (item) {
      let quantityLeft = 0

      try {
        if (item.purchase_order_position && item.purchase_order_position.procurement_position.suppliers_orders_position &&
          item.purchase_order_position.procurement_position.suppliers_orders_position.supplier_order_position_received) {
          item.purchase_order_position.procurement_position.suppliers_orders_position.supplier_order_position_received.forEach(element => {
            quantityLeft += element.quantity
          })
        }
        quantityLeft -= this.pickedAmount(item.purchase_order_position)
      } catch (error) {
        console.error(error)
      }

      return quantityLeft
    },
    pickedAmount (item) {
      if (item !== null && item.picked_amount.length !== 0 && item.picked_amount[0] && item.picked_amount[0].amount_picked) {
        return item.picked_amount[0].amount_picked
      } else {
        return 0
      }
    }

  },
  computed: {
    getItems () {
      this.total = this.$store.getters[InvoicePosition.getters.invoicePositions].length
      return this.$store.getters[InvoicePosition.getters.invoicePositions]
    },
    getPickedItems () {
      this.total = this.$store.getters[PickingPosition.getters.pickingPositions].length
      return this.$store.getters[PickingPosition.getters.pickingPositions]
    },
    selectedItem () {
      return this.$store.getters[Picking.getters.getSelectedPicking]
    },
    selectedPosition () {
      return this.$store.getters[InvoicePosition.getters.getSelectedInvoicePosition]
    },
    loading () {
      return this.$store.getters[Settings.getters.loading]
    },
    /*        getCreatingPurchaseOrderMessage () {
                      return this.$store.getters[PurchaseOrder.getters.getCreatingPurchaseOrderMessage]
                    }, */
    confirmOrderPositionDialogState () {
      return this.$store.getters[InvoicePosition.getters.getOpenDialogState]
    }
  },
  watch: {
    pagination: {
      handler () {
        this.loadItems()
      },
      deep: true
    },
    confirmOrderPositionDialogState: {
      handler (val) {
        if (!val) {
          this.loadItems()
        }
      },
      deep: true
    },
    search: {
      handler (val) {
        this.throttledLoadItems()
      },
      deep: true
    }
  }

}
</script>

<style scoped>

    th:focus {
        outline: none !important;
    }

</style>



// WEBPACK FOOTER //
// src/components/Invoices/Pickings/PickingPositions/PickingPositions.vue